import React, { useState, useEffect } from 'react'
import styled from "styled-components";
import { useDetectClickOutside } from "react-detect-click-outside";
import axios from "axios";
import playGame from "../img/icons/playGame.svg"
import { InputGroup } from "../components/Input";
import { ENV_CONFIG } from "../config/environment-unified";


export default function SelectGames({ placeholder, id, data, setdata, alert }) {
  const [Result, setResult] = useState([]);
  const [game, setGame] = useState("");
  const [input, setInput] = useState("");
  const [icon, setIcon] = useState(playGame);
  const [show, setshow] = useState(false);


useEffect(() => {
  if (input) {
    axios
      .get(ENV_CONFIG.SEARCH_GAME_ENDPOINT + input)
      .then((res) => {
        setResult(
          res.data.games.map((game) => ({
            _id: game.id || game.shortName || game.name, // ici tu mets l'id en priorité
            name: game.name,
            icon: game.icon,
          }))
        );
      })
      .catch((err) => {
        console.error("❌ Erreur recherche jeux :", err);
        setResult([]); // en cas d'erreur, on vide la liste
      });
  } else {
    setResult([]);
  }
}, [input]);


  const handleChange = (e) => {
    setshow(true)
    setdata("")
    setGame("")
    setInput(e.target.value)
    setIcon(playGame)

  }
  const ref = useDetectClickOutside({
    onTriggered: handleClickOut,
    triggerKeys: ["Escape"],
  });
  function handleClickOut() {
    setInput("")
    setshow(false)
    document.getElementById(id).value = "";

  }
  return (
    <div ref={ref} style={{ width: "100%", height: "auto", position: "relative" }} >
      <Input
        id={id}
        autocomplete="nope"
        onChange={(e) => { handleChange(e) }}
        placeholder={game === "" ? placeholder : game.name}
        option={game === "" ? true : false}
        alert={alert}
        type="search"
      />
      <Buttonc alert={alert} option={game === "" ? true : false} alt="game" src={icon} />
      {show && <SearchResult id={id}
        setGame={(e) => { setGame(e) }}

        setdata={(e) => { setdata(e) }}
        setshow={(e) => { setshow(e) }}
        setIcon={(e) => setIcon(e)}
        setInput={(e) => { setInput(e) }}
        input={input}
        res={Result} />}
    </div>
  )
}

const SearchResult = ({ id, setGame, setdata, setIcon, setshow, res }) => {
  const [newResult, setNewResult] = useState(null);
  useEffect(() => {
    if (res !== undefined) setNewResult(res);
    else setNewResult(null);

  }, [res]);
  return (
    <Result  >
      {newResult
        ? newResult?.slice(0, 4).map((game, index) => {
          return (
//             <Item onClick={(e) => {
//               e.stopPropagation()
// setdata({
//   id: game._id,
//   name: game.name,
// });
//               document.getElementById(id).value = "";
//               setIcon(game.icon);
//               setshow(false)
//               setGame(game)
//             }
//             } key={index}>
//               <Cover src={game.icon} />
//               <Title>{game.name}</Title>
//             </Item>
<Item onClick={(e) => {
  e.stopPropagation();
  setdata({
    gameId: game._id,   // mettre gameId (important!)
    gameName: game.name,
  });
  // document.getElementById(id).value = "";  --> supprimer cette ligne
  setIcon(game.icon);
  setshow(false);
  setGame(game);
}} key={index}>
  <Cover src={game.icon} />
  <Title>{game.name}</Title>
</Item>

          );
        })
        : ""}
    </Result>
  );
};


///////////////styling 
const Buttonc = styled.img`
  position: absolute;
  top : 20px;
  left: 8px;
  transform: translate(-0% , -50%);
  width: 16px;
  height: 16px;
  z-index: 23 !important;
  ${({ option }) =>
    !option &&
    `
    border-radius: 4px !important;
    width: 20px;
    height: 25px;
  `}
 
`;

const Input = styled(InputGroup)`
  width: calc(100% - 30px);
  background-color: ${({ theme }) => theme.color.secondaryBg};
  height: 40px;
  border-radius: 8px;
  padding: 0 0 0px 33px;
  color: ${({ theme }) => theme.color.darkerText};
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${({ theme }) => theme.color.darkerText};
    opacity: 1;
    font-size:   ${({ theme }) => theme.fontSize.xs};
;
  }
  :-ms-input-placeholder {
    color: ${({ theme }) => theme.color.darkerText};

    opacity: 1;
  }

  ${({ option }) =>
    option &&
    `
    ::placeholder,
    ::-webkit-input-placeholder {
        color: ${({ theme }) => theme.color.lighterText};
         opacity: 0.4;
        user-select: none;
;
  }
  `}
 
  z-index: 9; 
`;
const Title = styled.p`
  color: ${({ theme }) => theme.color.darkerText};
  font-family: "Poppins Medium";
  font-size: 14px;
`;

const Cover = styled.img`
  width: 25px;
  height: 25px;
  margin-right: 15px;
  border-radius: 8px;
  @media (max-width: 500px) {
    width: 20px;
    height: 20px;
  }
`;

const Item = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 12px;
  border-radius: 5px;
  width: calc(100% - 10px);
  &:hover {
    background-color: ${({ theme }) => theme.color.secondaryBg};
  }
  &:first-child {
    margin-top: 10px;
  }
  @media (max-width: 500px) {
    width: 100%;
  }
`;
const Result = styled.div`
  background-color: ${({ theme }) => theme.color.background};
  position: absolute;
  top: 107%;
  left: -5px;
  width: calc(100% + 10px);
  z-index: 8;
  border-radius: 0 0 8px 8px;
  padding: 0px 0 6px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: ${({ theme }) => theme.shadow.md};
  @media (max-width: 500px) {
    left: calc(-2% + 1px);
    width: calc(104% - 2px);
    display: ${({ text }) => (text ? "flex" : "flex")};
    top: 41.4px;
  }
`;